import { render } from "./EditObject.vue?vue&type=template&id=41450466&scoped=true"
import script from "./EditObject.vue?vue&type=script&lang=js"
export * from "./EditObject.vue?vue&type=script&lang=js"

import "./EditObject.vue?vue&type=style&index=0&id=41450466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41450466"]])

export default __exports__